var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-btn",class:{ 'gray': _vm.counting },on:{"click":_vm.sendCode}},[_c('span',[_vm._v(_vm._s(_vm.txtStr))])])}
var staticRenderFns = []

export { render, staticRenderFns }